import { memo } from 'react';

import { extractWorkflowFromInstanceName } from '@spotify/confidence-core-react';

import { useWorkflowExtension } from '../../hooks';
import type { WorkflowInstanceListItem } from '../../hooks/useListWorkflowInstances';
import { DefaultWorkflowTableRow } from '../DefaultWorkflowTableRow';

export const WorkflowInstanceExtensionRow = memo(
  ({
    workflowInstance,
    showTypeIcon = false,
  }: {
    workflowInstance: WorkflowInstanceListItem;
    showTypeIcon?: boolean;
  }) => {
    const workflowId = extractWorkflowFromInstanceName(workflowInstance.name);
    const extension = useWorkflowExtension({ workflowId: workflowId ?? '' });

    const TableRowComponent =
      extension?.workflowTableRowComponent ?? DefaultWorkflowTableRow;

    const icon =
      showTypeIcon && extension?.workflowIcon ? (
        <extension.workflowIcon />
      ) : undefined;

    return (
      <TableRowComponent
        kind={extension?.title}
        workflowInstance={workflowInstance}
        icon={icon}
      />
    );
  },
);
WorkflowInstanceExtensionRow.displayName = 'WorkflowInstanceExtensionRow';
